import { render, staticRenderFns } from "./mileage_item_info.vue?vue&type=template&id=afad5612&scoped=true"
import script from "./mileage_item_info.vue?vue&type=script&lang=js"
export * from "./mileage_item_info.vue?vue&type=script&lang=js"
import style0 from "./mileage_item_info.vue?vue&type=style&index=0&id=afad5612&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afad5612",
  null
  
)

export default component.exports